export default function Test() {
    return (
      <div id="app">
        <a href="https://plainenglish.io" target="_blank" rel="noreferrer">
          In Plain English
        </a>{" "}
        <br />
        <br /> <a
          href="https://plainenglish.io/blog"
          target="_blank"
          rel="noreferrer"
        >
          In Plain English Blog
        </a>
      </div>
    );
  }